import React, { useEffect, useContext, useState } from "react";
import { closeLayerFn, openLayerFn } from "../Layout";
import { CalendarList, goToday, nextMonth, prevMonth } from "./Calendar";

// Provider
import { AppContext } from "../../components/AppProvider";

import Swiper from "../../modules/env/swiper-bundle.min.js";

export default (props) => {
    const {setTitle, handleDialog} = props;
    
    //저장변수
    let startampmInvalue;
    let starthourInvalue;
    let startminuteInvalue;

    //세팅 변수
    let startpickslideAmpm;
    let startpickslideHour;
    let startpickslideMinute;

	// 슬라이드 설정 세팅(팝업 동시)
	const startpickerStartFn = () => {
		//오전오후
		startpickslideAmpm = new Swiper('.pickslide-ampm-start', {
            // Optional parameters
            direction: 'vertical',
            //loop: true,
            slidesPerView: 3,
            centeredSlides: true,
            on:{
                init: function(){
                    startampmInvalue = $(".pickslide-ampm-start .swiper-slide-active span").html();
                },
                slideChangeTransitionEnd: function(){
                    startampmInvalue = $(".pickslide-ampm-start .swiper-slide-active span").html();
                },
            },
		});

		//시
		startpickslideHour = new Swiper('.pickslide-hour-start', {
            // Optional parameters
            direction: 'vertical',
            loop: true,
            slidesPerView: 3,
            centeredSlides: true,
            initialSlide: 8,
            on:{
                slideChangeTransitionEnd: function(){
                    starthourInvalue = $(".pickslide-hour-start .swiper-slide-active span").html();
                },
            },
		});

		//분
		startpickslideMinute = new Swiper('.pickslide-minute-start', {
            // Optional parameters
            direction: 'vertical',
            loop: true,
            slidesPerView: 3,
            centeredSlides: true,
            on:{
                slideChangeTransitionEnd: function(){
                    startminuteInvalue = $(".pickslide-minute-start .swiper-slide-active span").html();
                },
            },
		});

	}

	//슬라이드 설정 해제(팝업 닫기 직전)
	const startcalpickerEndFn = () => {
		startpickslideAmpm.destroy();
		startpickslideHour.destroy();
		startpickslideMinute.destroy();
	}

    useEffect(() => {
        ////위치 레이어 열기
        $(".open-location-layer").click(function(){
            closeLayerFn($(".add-date-layer"));
            openLayerFn($(".location-inp-layer"));
        });
        //닫기
        $(".location-inp-layer .tbns-area a").click(function(){
            closeLayerFn($(".location-inp-layer"));
            openLayerFn($(".add-date-layer"));

            if( $(this).hasClass("wht") ){
                $(".open-location-layer").addClass("in");
                
                var locVal = $(".location-inp-layer .check-area input:checked + i + div span").html();
                $(".open-location-layer").html(locVal);
            }

        });

        ////시작 - 레이어 안 달력
        //열기
        $(".open-start-date").click(function(){
            setTitle("START");
            closeLayerFn($(".add-date-layer"));
            openLayerFn($(".start-cal-layer"));	
            startpickerStartFn();
        });

        //열기
        $(".open-end-date").click(function(){
            setTitle("END");
            closeLayerFn($(".add-date-layer"));
            openLayerFn($(".start-cal-layer"));	
            startpickerStartFn();

            
        });

        //닫기
        $(".start-cal-layer .tbns-area a").click(function(){
            // $('.calendar-slide-inlayer-start').slick('unslick');
            if($(this).hasClass("wht") || $(this).hasClass("wht2")) {
                if(!startselectDay) {
                    handleDialog("", "날짜를 선택하세요.", "");
                    return;
                }
            } else {
                startcalpickerEndFn();
                closeLayerFn($(".start-cal-layer"));
                openLayerFn($(".add-date-layer"));
                return;
            }

            startselectYear = $(".start-cal-layer .arrows-yearmonth span em").html().split(' ')[0];
            startselectMon = $(".start-cal-layer .arrows-yearmonth span em").html().split(' ')[2];

            if(startselectMon.length < 2) {
                startselectMon = "0" + startselectMon;
            }

            if(startselectDay.length < 2) {
                startselectDay = "0" + startselectDay;
            }

            let resultPrint = startselectYear+"-"+startselectMon+"-"+startselectDay + " " + startampmInvalue + " " + starthourInvalue + ":" + startminuteInvalue;

            // from <= to 비교 필요
            if( $(this).hasClass("wht") ){
                $(".open-start-date").addClass("in");
                $(".open-start-date").html(resultPrint);
            } else if($(this).hasClass("wht2")){
                $(".open-end-date").addClass("in");
                $(".open-end-date").html(resultPrint);
            }

            startcalpickerEndFn();
            closeLayerFn($(".start-cal-layer"));
            openLayerFn($(".add-date-layer"));

        });

        ///달력 날짜 선택
        let startselectYear = $(".start-cal-layer .arrows-yearmonth span em").html();		//년(year)
        let startselectMon = $(".start-cal-layer .arrows-yearmonth span em").html();		//월(month)
        let startselectDay = $(".start-cal-layer .calendar-container .calendar-box ul li.on span").html();		// 일(day)

        //시작 달력 날 선택
        $(".start-cal-layer .calendar-container .calendar-box ul li").click(function(){
            if(!$(this).hasClass("on")){
                $(".start-cal-layer .calendar-container .calendar-box ul li").removeClass("on");
                $(this).addClass("on");
                startselectDay = $(this).find("span").html();
            }
        });

        ////반복 - 레이어
        //열기
        $(".open-repeat-layer").click(function(){
            closeLayerFn($(".add-date-layer"));
            openLayerFn($(".repeat-layer"));	
        });

        //닫기
        $(".repeat-layer .tbns-area a").click(function(){
            closeLayerFn($(".repeat-layer"));
            openLayerFn($(".add-date-layer"));

            if( $(this).hasClass("wht") ){
                $(".open-repeat-layer").addClass("in");
                var repText = $(".repeat-check .check-area label input:checked + i + div span").html();
                var repCheck = $(".repeat-check .check-area label input:checked").length;

                if(repCheck){
                    //설정된 반복
                    $(".open-repeat-layer").html( repText ); 
                }else{
                    //맞춤 반복
                    $(".open-repeat-layer").html( customRepeatResult ); 
                }
            }
        });

    }, []);
    return(
        <div className="blacklayer-container add-date-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div className="blgrn-box priv">
                    <div className="blgr-title">일정추가</div>
                    
                    <div className="pinkinlayer-inp-boxes">
                        <div>
                            <span>제목</span>
                            <div className="inp">
                                <input type="text" className="textbox" id="customTitle" placeholder="제목을 입력해주세요." />
                            </div>
                        </div>
                        <div>
                            <span>위치</span>
                            <div className="btn-select">
                                <a className="r-arrbtn open-location-layer">위치를 선택해주세요.</a>
                            </div>
                        </div>
                        <div>
                            <span>시작</span>
                            <div className="btn-select">
                                <a className="r-arrbtn open-start-date in">시작 일자를 선택해주세요.</a>
                            </div>
                        </div>
                        <div>
                            <span>종료</span>
                            <div className="btn-select">
                                <a className="r-arrbtn open-end-date">종료 일자를 선택해주세요.</a>
                            </div>
                        </div>
                        <div>
                            <span>반복</span>
                            <div className="btn-select">
                                <a className="r-arrbtn open-repeat-layer">반복 설정을 해주세요.</a>
                            </div>
                        </div>
                        <div>
                            <span>알림</span>
                            <div className="btn-select">
                                <a className="r-arrbtn open-alarm-layer">알림 설정을 해주세요.</a>
                            </div>
                        </div>
                        <div>
                            <span>메모</span>
                            <div className="text-area">
                                <textarea placeholder="메모를 입력해 주세요." className="textarea-box he1"></textarea>
                            </div>
                        </div>

                    </div>

                    <div className="tbns-area">
                        <a className="btn-round gray">취소</a>
                        <a className="btn-round wht">확인</a>
                    </div>
                </div>
            </div>
        </div>
    );
}
const _hsptList = [
    {hsptNm: '의연병원',address: '서울특별시 서초구 바우뫼로222 영진빌딩 4층'},
    {hsptNm: '의연내과',address: '서울특별시 서초구 바우뫼로222 영진빌딩 4층'},
    {hsptNm: '의연병원',address: '서울특별시 서초구 바우뫼로222 영진빌딩 4층'},
    {hsptNm: '의연내과',address: '서울특별시 서초구 바우뫼로222 영진빌딩 4층'},
    {hsptNm: '의연병원',address: '서울특별시 서초구 바우뫼로222 영진빌딩 4층'},
    {hsptNm: '의연내과',address: '서울특별시 서초구 바우뫼로222 영진빌딩 4층'},
    {hsptNm: '의연병원',address: '서울특별시 서초구 바우뫼로222 영진빌딩 4층'},
    {hsptNm: '의연내과',address: '서울특별시 서초구 바우뫼로222 영진빌딩 4층'},
    {hsptNm: '의연병원',address: '서울특별시 서초구 바우뫼로222 영진빌딩 4층'},
    {hsptNm: '의연내과',address: '서울특별시 서초구 바우뫼로222 영진빌딩 4층'},
    {hsptNm: '의연병원',address: '서울특별시 서초구 바우뫼로222 영진빌딩 4층'},
    {hsptNm: '의연내과',address: '서울특별시 서초구 바우뫼로222 영진빌딩 4층'},
];

export const Location = (props) => {
    const { userinfo, cfg, phonecfg, auth, dispatch } = useContext(AppContext);

    const [ hsptList, setHsptList ] = useState();

    //위치정보, 유저정보(userToken), 검색정보
    const request9999 = (srchInfo) => {
        PostApi999(userinfo, cfg, phonecfg, srchInfo)
        .then(res => {
            if(res.resultMsg === 'SUCCESS') {
                setHsptList(res.result);
            } else {
                console.log("resultMsg=====" + resultMsg);
            }
        })
        .catch(err => {
            console.log(err);
        })
    }

    return(
        <div className="blacklayer-container location-inp-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div className="blgrn-box priv">
                    <div className="blgr-title">위치</div>
                    
                    <div className="pinkinlayer-inp-boxes">
                        <div>
                            <div className="search-box btn-open-map">
                                <input type="text" className="textbox search" placeholder="위치입력" />
                                <a></a>
                            </div>
                        </div>
                        <div>
                            <span>현재위치</span>
                            <div className="check-area" style={{overflow:'auto', height:'18rem'}}>
                                {_hsptList.map((result, i) => (
                                    <Hospital 
                                        hsptNm={result.hsptNm}
                                        address={result.address}
                                        key={i}
                                    />
                                ))}
                            </div>
                        </div>
                        <div>
                            <span>최근위치</span>
                            <div className="check-area">
                                <Hospital />
                            </div>
                        </div>
                    </div>

                    <div className="tbns-area">
                        <a className="btn-round gray">취소</a>
                        <a className="btn-round wht">확인</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

const Hospital = (props) => {
    const { hsptNm, address } = props

    const hsptClick = () => {
        closeLayerFn($(".location-inp-layer"));
        openLayerFn($(".add-date-layer"));

        $(".open-location-layer").addClass("in");
        
        var locVal = $(".location-inp-layer .check-area input:checked + i + div span").html();
        $(".open-location-layer").html(locVal);

        // check reset 추가, 검색값 지우기, 검색초기화
        $(".radio1").prop("checked", false);
        $(".search").val('');
    }
    return(
        <label>
            <input type="radio" name="radio1" onClick={()=> hsptClick()} /><i></i>
            <div>
                <span>
                    {hsptNm ? hsptNm : '서초병원'}
                </span>
                <p>
                    {address ? address : '연수구 독배로40번길 11 효명프라자'}
                </p>
            </div>
        </label>
    );
}

export const TargetDateLayer = (props) => {
    const { title } = props;

    // useEffect(() => {
    //     goToday(".year-month2", ".popupDates");
    // }, []);
    return(
        <div className="blacklayer-container start-cal-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div className="blgrn-box priv">
                    <div className="blgr-title">{title === "START" ? '시작' : '종료'}</div>

                    <div>
                        <div className="calendar-container">
                            <div className="arrows-yearmonth inslide">
                                <a className="btn-left" onClick={()=>prevMonth(".year-month2", ".popupDates")}></a>
                                <span className="year-month2">
                                </span>
                                <a className="btn-right" onClick={()=>nextMonth(".year-month2", ".popupDates")}></a>
                            </div>

                            <div className="calendar-slide-inlayer-start">
                                <CalendarList targetDate="popupDates"/>
                            </div>
                        </div>
                    </div>

                    {/* 날짜선택 */}
                    <div>
                        <DatePickerAmPm />
                    </div>
                    <div className="tbns-area">
                        <a className="btn-round gray">취소</a>
                        <a className={title === "START" ? "btn-round wht" : "btn-round wht2"}>확인</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const RepeatLayer = () => {
    useEffect(() => {
        //열기
        $(".open-repeat-layer").click(function(){
            closeLayerFn($(".add-date-layer"));
            openLayerFn($(".repeat-layer"));	

        });

        //닫기
        $(".repeat-layer .tbns-area a").click(function(){
            closeLayerFn($(".repeat-layer"));
            openLayerFn($(".add-date-layer"));

            if( $(this).hasClass("wht") ){
                $(".open-repeat-layer").addClass("in");
                let repText = $(".repeat-check .check-area label input:checked + i + div span").html();
                let repCheck = $(".repeat-check .check-area label input:checked").length;
                //console.log(repText);

                if(repCheck){//설정된 반복
                    $(".open-repeat-layer").html( repText ); 
                }else{//맞춤 반복
                    $(".open-repeat-layer").html( customRepeatResult ); 
                }

            }
        });
    }, [])
    return(
        <div className="blacklayer-container repeat-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div className="blgrn-box priv">
                    <div className="blgr-title">반복</div>

                    <div>
                        <div className="pinkinlayer-inp-boxes repeat-check">
                            <div>
                                <div className="check-area one">
                                    <label>
                                        <input type="radio" name="radio2" /><i></i>
                                        <div>
                                            <span>안함</span>
                                        </div>
                                    </label>	
                                </div>
                            </div>
                            <div>
                                <div className="check-area one">
                                    <label>
                                        <input type="radio" name="radio2" /><i></i>
                                        <div>
                                            <span>매일</span>
                                        </div>
                                    </label>	
                                </div>
                            </div>
                            <div>
                                <div className="check-area one">
                                    <label>
                                        <input type="radio" name="radio2" /><i></i>
                                        <div>
                                            <span>매주</span>
                                        </div>
                                    </label>	
                                </div>
                            </div>
                            <div>
                                <div className="check-area one">
                                    <label>
                                        <input type="radio" name="radio2" /><i></i>
                                        <div>
                                            <span>매월</span>
                                        </div>
                                    </label>	
                                </div>
                            </div>
                            <div>
                                <div className="check-area one">
                                    <label>
                                        <input type="radio" name="radio2" /><i></i>
                                        <div>
                                            <span>매년</span>
                                        </div>
                                    </label>	
                                </div>
                            </div>
                        </div>

                        <div className="pinkinlayer-inp-boxes">
                            <div>
                                <div className="btn-select">
                                    <a className="r-arrbtn open-repeatcustom-layer">맞춤 반복 <em></em></a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="tbns-area">
                        <a className="btn-round gray">취소</a>
                        <a className="btn-round wht">확인</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const RepeatCustomLayer = () => {

    let custDayslideAmpm;
	let custWeek1slideAmpm;
	let custWeek2slideAmpm;
	let custYear1slideAmpm;
	let custYear2slideAmpm;
	let custYear3slideAmpm;

	let custDayInvalue;
	let custWeek1Invalue;
	let custWeek2Invalue;
	let custYear1Invalue;
	let custYear2Invalue;
	let custYear3Invalue;

    let mCustomYear = $(".calendar-container.mon-custom .arrows-yearmonth span em.on i.y").html();
	let mCustomMonth = $(".calendar-container.mon-custom .arrows-yearmonth span em.on i.m").html();
	let mCustomDay = $(".calendar-slide-inlayer-custom .calendar-box ul li.on span").html();

    const custDaypickerStartFn = () => {
		//몇일
		custDayslideAmpm = new Swiper('.pickslide-cut-day', {
            // Optional parameters
            direction: 'vertical',
            loop: true,
            slidesPerView: 5,
            centeredSlides: true,
            on:{
                slideChangeTransitionEnd: function(){
                    custDayInvalue = $(".pickslide-cut-day .swiper-slide-active span").html();
                },
            },
		});

		//몇주
		custWeek1slideAmpm = new Swiper('.pickslide-cut-week1', {
		  // Optional parameters
            direction: 'vertical',
            loop: true,
            slidesPerView: 5,
            centeredSlides: true,
            on:{
                slideChangeTransitionEnd: function(){
                    custWeek1Invalue = $(".pickslide-cut-week1 .swiper-slide-active span").html();
                },
            },
		});

		custWeek2slideAmpm = new Swiper('.pickslide-cut-week2', {
            // Optional parameters
            direction: 'vertical',
            loop: true,
            slidesPerView: 5,
            centeredSlides: true,
            on:{
                slideChangeTransitionEnd: function(){
                    custWeek2Invalue = $(".pickslide-cut-week2 .swiper-slide-active span").html();
                },
            },
		});



		//몇년
		custYear1slideAmpm = new Swiper('.pickslide-cut-year1', {
            // Optional parameters
            direction: 'vertical',
            //loop: true,
            slidesPerView: 3,
            centeredSlides: true,
            on:{
                init: function(){
                    custYear1Invalue = $(".pickslide-cut-year1 .swiper-slide-active span").html();
                },
                slideChangeTransitionEnd: function(){
                    custYear1Invalue = $(".pickslide-cut-year1 .swiper-slide-active span").html();
                },
            },
		});

		custYear3slideAmpm = new Swiper('.pickslide-cut-year3', {
            // Optional parameters
            direction: 'vertical',
            loop: true,
            slidesPerView: 3,
            centeredSlides: true,
            on:{
                slideChangeTransitionEnd: function(){
                    custYear3Invalue = $(".pickslide-cut-year3 .swiper-slide-active span").html();
                },
            },
		});
	}

    //슬라이드 설정 해제
	const custDaypickerEndFn = () => {
		custDayslideAmpm.destroy();

		custWeek1slideAmpm.destroy();
		custWeek2slideAmpm.destroy();

		custYear1slideAmpm.destroy();
		custYear3slideAmpm.destroy();

	}

    useEffect(() => {
        // goToday(".year-month-repeat", ".repeatCalendar");

        $(".pick-cutyear-select ul li a").click(function(){
            $(this).toggleClass("on");
        });

        ///// 반복 안 - 맞춤반복
        //열기
        $(".open-repeatcustom-layer").click(function(){
            closeLayerFn($(".repeat-layer"));
            openLayerFn($(".repeat-custom-layer"));
            
            //몇일
            custDaypickerStartFn();
        });
        //닫기
        let customRepeatResult = "";
        $(".repeat-custom-layer .tbns-area a").click(function(){
            custDaypickerEndFn();
            closeLayerFn($(".repeat-custom-layer"));
            openLayerFn($(".repeat-layer"));
            
            if( $(this).hasClass("wht") ){
                $(".pinkinlayer-inp-boxes.repeat-check label input").prop('checked', false);
                $(".open-repeatcustom-layer").addClass("in");

                //$(".open-repeatcustom-layer").html();

                if( tabSectionIdx == 0 ){ //몇일
                    customRepeatResult = custDayInvalue + " 마다 반복";
                }else if(tabSectionIdx == 1){ //몇주
                    customRepeatResult = custWeek1Invalue +" "+custWeek2Invalue+ " 마다 반복";
                }else if(tabSectionIdx == 2){ //몇월
                    // mCustomMonth = $(".calendar-container.mon-custom .arrows-yearmonth span em.on i.m").html();
                    mCustomDay = $(".calendar-slide-inlayer-custom .calendar-box ul li.on span").html();
                    // customRepeatResult = mCustomMonth+"월 "+mCustomDay+"일"+ " 마다 반복";
                    customRepeatResult = "매월 "+mCustomDay+"일"+ " 마다 반복";
                }else if(tabSectionIdx == 3){ //몇년
                    var inMonthVal = "";
                    if($(".pick-cutyear-select ul li a").hasClass("on")){
                        $(".pick-cutyear-select ul li").each(function(){
                            if( $(this).find("a").hasClass("on") ){
                                inMonthVal += $(this).find("a").html()+" ";
                            }
                        });
                        custYear2Invalue = inMonthVal;
                    }else{
                        custYear2Invalue = "월미정";
                    }
                    customRepeatResult = custYear1Invalue+" "+custYear2Invalue+" "+custYear3Invalue+ " 마다 반복";
                }

                $(".open-repeatcustom-layer em").html(" ("+customRepeatResult+")");	
            }

        });

        let tabSectionIdx = 0;

        //몇일,몇주,몇월,몇년 탭 버튼
        $(".pinkinlayer-inp-boxes ul.btn-sel li a").click(function(){
            if( !$(this).hasClass("on") ){
                tabSectionIdx = $(this).parent().index();
                $(".pinkinlayer-inp-boxes ul.btn-sel li a").removeClass("on");
                $(this).addClass("on");

                if(tabSectionIdx == 2){
                    custDaypickerEndFn();
                    $(".pinkinlayer-inp-boxes .tap-section > div").hide();
                    $(".pinkinlayer-inp-boxes .tap-section > div").eq(tabSectionIdx).show();
                    
                    $('.calendar-slide-inlayer-custom').addClass("check");
                    // $('.calendar-slide-inlayer-custom').slick({
                    //     infinite: false,
                    //     initialSlide:1,
                    //     arrows:false,
                    // });

                }else{
                    if( $('.calendar-slide-inlayer-custom').hasClass("check") ){
                        // $('.calendar-slide-inlayer-custom').slick('unslick');
                        $('.calendar-slide-inlayer-custom').removeClass("check");
                    }
                    custDaypickerEndFn();
                    $(".pinkinlayer-inp-boxes .tap-section > div").hide();
                    $(".pinkinlayer-inp-boxes .tap-section > div").eq(tabSectionIdx).show();
                    custDaypickerStartFn();
                }
            }
        });

        //몇월 날짜 선택
        $(".calendar-slide-inlayer-custom .calendar-box ul li").click(function(){
            $(".calendar-slide-inlayer-custom .calendar-box ul li").removeClass("on");
            $(this).addClass("on");
        });
    }, [])
    return(
        <div className="blacklayer-container repeat-custom-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div className="blgrn-box priv">
                    <div className="blgr-title">반복</div>
                    <div className="pinkinlayer-inp-boxes">
                        <div>
                            <span>반복주기</span>
                            <div>
                                <ul className="btn-sel">
                                    <li><a className="on">몇일</a></li>
                                    <li><a >몇주</a></li>
                                    <li><a >몇월</a></li>
                                    <li><a >몇년</a></li>
                                </ul>
                            </div>
                        </div>
                        <div>
                            <span>반복</span>
                            <div className="tap-section">
                                <div>
                                    <div className="picker-container">
                                        <div className="swiper-container pickslide-cut-day">					
                                            <div className="swiper-wrapper">
                                                <div className="swiper-slide"><span>1일</span></div>
                                                <div className="swiper-slide"><span>2일</span></div>
                                                <div className="swiper-slide"><span>3일</span></div>
                                                <div className="swiper-slide"><span>4일</span></div>
                                                <div className="swiper-slide"><span>5일</span></div>
                                                <div className="swiper-slide"><span>6일</span></div>
                                                <div className="swiper-slide"><span>7일</span></div>
                                                <div className="swiper-slide"><span>8일</span></div>
                                                <div className="swiper-slide"><span>9일</span></div>
                                                <div className="swiper-slide"><span>10일</span></div>
                                                <div className="swiper-slide"><span>11일</span></div>
                                                <div className="swiper-slide"><span>12일</span></div>
                                                <div className="swiper-slide"><span>13일</span></div>
                                                <div className="swiper-slide"><span>14일</span></div>
                                                <div className="swiper-slide"><span>15일</span></div>
                                                <div className="swiper-slide"><span>16일</span></div>
                                                <div className="swiper-slide"><span>17일</span></div>
                                                <div className="swiper-slide"><span>18일</span></div>
                                                <div className="swiper-slide"><span>19일</span></div>
                                                <div className="swiper-slide"><span>21일</span></div>
                                                <div className="swiper-slide"><span>22일</span></div>
                                                <div className="swiper-slide"><span>23일</span></div>
                                                <div className="swiper-slide"><span>24일</span></div>
                                                <div className="swiper-slide"><span>25일</span></div>
                                                <div className="swiper-slide"><span>26일</span></div>
                                                <div className="swiper-slide"><span>27일</span></div>
                                                <div className="swiper-slide"><span>28일</span></div>
                                                <div className="swiper-slide"><span>29일</span></div>
                                                <div className="swiper-slide"><span>30일</span></div>
                                                <div className="swiper-slide"><span>31일</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="picker-container w2">
                                        <div className="swiper-container pickslide-cut-week1">					
                                            <div className="swiper-wrapper">
                                                <div className="swiper-slide"><span>1주</span></div>
                                                <div className="swiper-slide"><span>2주</span></div>
                                                <div className="swiper-slide"><span>3주</span></div>
                                                <div className="swiper-slide"><span>4주</span></div>
                                                <div className="swiper-slide"><span>5주</span></div>
                                            </div>
                                        </div>

                                        <div className="swiper-container pickslide-cut-week2">					
                                            <div className="swiper-wrapper">
                                                <div className="swiper-slide"><span>월요일</span></div>
                                                <div className="swiper-slide"><span>화요일</span></div>
                                                <div className="swiper-slide"><span>수요일</span></div>
                                                <div className="swiper-slide"><span>목요일</span></div>
                                                <div className="swiper-slide"><span>금요일</span></div>
                                                <div className="swiper-slide"><span>토요일</span></div>
                                                <div className="swiper-slide"><span>일요일</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="calendar-container mon-custom">
                                        <div className="arrows-yearmonth">
                                            <a className="btn-left" onClick={() => prevMonth(".year-month-repeat", ".repeatCalendar")}></a>
                                            <span className="year-month-repeat">
                                            </span>
                                            <a className="btn-right" onClick={() => nextMonth(".year-month-repeat", ".repeatCalendar")}></a>
                                        </div>

                                        <div className="calendar-slide-inlayer-custom">
                                            <CalendarList targetDate="repeatCalendar" />
                                        </div>
                                    </div>

                                </div>
                                <div>
                                    <div className="picker-container w2 retbpad">
                                        <div className="swiper-container pickslide-cut-year1 thrbox">
                                            <div className="swiper-wrapper">
                                                <div className="swiper-slide"><span>1년</span></div>
                                                <div className="swiper-slide"><span>2년</span></div>
                                                <div className="swiper-slide"><span>3년</span></div>
                                                <div className="swiper-slide"><span>4년</span></div>
                                                <div className="swiper-slide"><span>5년</span></div>
                                            </div>
                                        </div>
                                        
                                        {/* <div className="swiper-container pickslide-cut-year2 thrbox">					
                                            <div className="swiper-wrapper">
                                                <div className="swiper-slide"><span>1월</span></div>
                                                <div className="swiper-slide"><span>2월</span></div>
                                                <div className="swiper-slide"><span>3월</span></div>
                                                <div className="swiper-slide"><span>4월</span></div>
                                                <div className="swiper-slide"><span>5월</span></div>
                                                <div className="swiper-slide"><span>6월</span></div>
                                                <div className="swiper-slide"><span>7월</span></div>
                                                <div className="swiper-slide"><span>8월</span></div>
                                                <div className="swiper-slide"><span>9월</span></div>
                                                <div className="swiper-slide"><span>10월</span></div>
                                                <div className="swiper-slide"><span>11월</span></div>
                                                <div className="swiper-slide"><span>12월</span></div>
                                            </div>
                                        </div> */}

                                        <div className="swiper-container pickslide-cut-year3 thrbox">					
                                            <div className="swiper-wrapper">
                                                <div className="swiper-slide"><span>1일</span></div>
                                                <div className="swiper-slide"><span>2일</span></div>
                                                <div className="swiper-slide"><span>3일</span></div>
                                                <div className="swiper-slide"><span>4일</span></div>
                                                <div className="swiper-slide"><span>5일</span></div>
                                                <div className="swiper-slide"><span>6일</span></div>
                                                <div className="swiper-slide"><span>7일</span></div>
                                                <div className="swiper-slide"><span>8일</span></div>
                                                <div className="swiper-slide"><span>9일</span></div>
                                                <div className="swiper-slide"><span>10일</span></div>
                                                <div className="swiper-slide"><span>12일</span></div>
                                                <div className="swiper-slide"><span>13일</span></div>
                                                <div className="swiper-slide"><span>14일</span></div>
                                                <div className="swiper-slide"><span>15일</span></div>
                                                <div className="swiper-slide"><span>16일</span></div>
                                                <div className="swiper-slide"><span>17일</span></div>
                                                <div className="swiper-slide"><span>18일</span></div>
                                                <div className="swiper-slide"><span>19일</span></div>
                                                <div className="swiper-slide"><span>21일</span></div>
                                                <div className="swiper-slide"><span>22일</span></div>
                                                <div className="swiper-slide"><span>23일</span></div>
                                                <div className="swiper-slide"><span>24일</span></div>
                                                <div className="swiper-slide"><span>25일</span></div>
                                                <div className="swiper-slide"><span>26일</span></div>
                                                <div className="swiper-slide"><span>27일</span></div>
                                                <div className="swiper-slide"><span>28일</span></div>
                                                <div className="swiper-slide"><span>29일</span></div>
                                                <div className="swiper-slide"><span>30일</span></div>
                                                <div className="swiper-slide"><span>31일</span></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pick-cutyear-select">
                                        <ul>
                                            <li><a>1월</a></li>
                                            <li><a>2월</a></li>
                                            <li><a>3월</a></li>
                                            <li><a>4월</a></li>
                                            <li><a>5월</a></li>
                                            <li><a>6월</a></li>
                                            <li><a>7월</a></li>
                                            <li><a>8월</a></li>
                                            <li><a>9월</a></li>
                                            <li><a>10월</a></li>
                                            <li><a>11월</a></li>
                                            <li><a>12월</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tbns-area">
                        <a className="btn-round gray">취소</a>
                        <a className="btn-round wht">확인</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

const DatePickerAmPm = () => {
    //저장변수
    return(
        <div className="picker-container w3 cunder">
            <div className="swiper-container pickslide-ampm-start">
                <div className="swiper-wrapper">
                    <div className="swiper-slide"><span>오전</span></div>
                    <div className="swiper-slide"><span>오후</span></div>
                </div>
            </div>

            <div className="swiper-container pickslide-hour-start">
                <div className="swiper-wrapper">
                    <div className="swiper-slide"><span>01</span></div>
                    <div className="swiper-slide"><span>02</span></div>
                    <div className="swiper-slide"><span>03</span></div>
                    <div className="swiper-slide"><span>04</span></div>
                    <div className="swiper-slide"><span>05</span></div>
                    <div className="swiper-slide"><span>06</span></div>
                    <div className="swiper-slide"><span>07</span></div>
                    <div className="swiper-slide"><span>08</span></div>
                    <div className="swiper-slide"><span>09</span></div>
                    <div className="swiper-slide"><span>10</span></div>
                    <div className="swiper-slide"><span>11</span></div>
                    <div className="swiper-slide"><span>12</span></div>
                </div>
            </div>

            <div className="swiper-container pickslide-minute-start">					
                <div className="swiper-wrapper">
                    <div className="swiper-slide"><span>00</span></div>
                    <div className="swiper-slide"><span>01</span></div>
                    <div className="swiper-slide"><span>02</span></div>
                    <div className="swiper-slide"><span>03</span></div>
                    <div className="swiper-slide"><span>04</span></div>
                    <div className="swiper-slide"><span>05</span></div>
                    <div className="swiper-slide"><span>06</span></div>
                    <div className="swiper-slide"><span>07</span></div>
                    <div className="swiper-slide"><span>08</span></div>
                    <div className="swiper-slide"><span>09</span></div>
                    <div className="swiper-slide"><span>10</span></div>
                    <div className="swiper-slide"><span>11</span></div>
                    <div className="swiper-slide"><span>12</span></div>
                    <div className="swiper-slide"><span>13</span></div>
                    <div className="swiper-slide"><span>14</span></div>
                    <div className="swiper-slide"><span>15</span></div>
                    <div className="swiper-slide"><span>16</span></div>
                    <div className="swiper-slide"><span>17</span></div>
                    <div className="swiper-slide"><span>18</span></div>
                    <div className="swiper-slide"><span>19</span></div>
                    <div className="swiper-slide"><span>20</span></div>
                    <div className="swiper-slide"><span>21</span></div>
                    <div className="swiper-slide"><span>22</span></div>
                    <div className="swiper-slide"><span>23</span></div>
                    <div className="swiper-slide"><span>24</span></div>
                    <div className="swiper-slide"><span>25</span></div>
                    <div className="swiper-slide"><span>26</span></div>
                    <div className="swiper-slide"><span>27</span></div>
                    <div className="swiper-slide"><span>28</span></div>
                    <div className="swiper-slide"><span>29</span></div>
                    <div className="swiper-slide"><span>30</span></div>
                    <div className="swiper-slide"><span>31</span></div>
                    <div className="swiper-slide"><span>32</span></div>
                    <div className="swiper-slide"><span>33</span></div>
                    <div className="swiper-slide"><span>34</span></div>
                    <div className="swiper-slide"><span>35</span></div>
                    <div className="swiper-slide"><span>36</span></div>
                    <div className="swiper-slide"><span>37</span></div>
                    <div className="swiper-slide"><span>38</span></div>
                    <div className="swiper-slide"><span>39</span></div>
                    <div className="swiper-slide"><span>40</span></div>
                    <div className="swiper-slide"><span>41</span></div>
                    <div className="swiper-slide"><span>42</span></div>
                    <div className="swiper-slide"><span>43</span></div>
                    <div className="swiper-slide"><span>44</span></div>
                    <div className="swiper-slide"><span>45</span></div>
                    <div className="swiper-slide"><span>46</span></div>
                    <div className="swiper-slide"><span>47</span></div>
                    <div className="swiper-slide"><span>48</span></div>
                    <div className="swiper-slide"><span>49</span></div>
                    <div className="swiper-slide"><span>50</span></div>
                    <div className="swiper-slide"><span>51</span></div>
                    <div className="swiper-slide"><span>52</span></div>
                    <div className="swiper-slide"><span>53</span></div>
                    <div className="swiper-slide"><span>54</span></div>
                    <div className="swiper-slide"><span>55</span></div>
                    <div className="swiper-slide"><span>56</span></div>
                    <div className="swiper-slide"><span>57</span></div>
                    <div className="swiper-slide"><span>58</span></div>
                    <div className="swiper-slide"><span>59</span></div>
                </div>
            </div>
            <i className="dots"></i>
        </div>
    );
}

export const Allim = (props) => {

    let alarm1slideAmpm;
	let alarm2slideAmpm;

	let alarm1Invalue;
	let alarm2Invalue;

	const alarmpickerStartFn = () => {
		//
		alarm1slideAmpm = new Swiper('.pickslide-alarm1', {
		  // Optional parameters
            direction: 'vertical',
		  //loop: true,
            slidesPerView: 5,
            centeredSlides: true,
            on:{
                init: function(){
                    alarm1Invalue = $(".pickslide-alarm1 .swiper-slide-active span").html();
                },
                slideChangeTransitionEnd: function(){
                    alarm1Invalue = $(".pickslide-alarm1 .swiper-slide-active span").html();
                },
            },
		});

		alarm2slideAmpm = new Swiper('.pickslide-alarm2', {
            // Optional parameters
            direction: 'vertical',
            loop: true,
            slidesPerView: 5,
            centeredSlides: true,
            on:{
                slideChangeTransitionEnd: function(){
                    alarm2Invalue = $(".pickslide-alarm2 .swiper-slide-active span").html();
                },
            },
		});
	}

	const alarmpickerEndFn = () => {
		alarm1slideAmpm.destroy();
		alarm2slideAmpm.destroy();
	}

    useEffect(() => {
        //열기
        $(".open-alarm-layer").click(function(){
            closeLayerFn($(".add-date-layer"));
            openLayerFn($(".alarm-layer"));	

            alarmpickerStartFn();
        });

        //닫기
        $(".alarm-layer .tbns-area a").click(function(){
            alarmpickerEndFn();
            closeLayerFn($(".alarm-layer"));
            openLayerFn($(".add-date-layer"));	

            if( $(this).hasClass("wht") ){
                var alarmResult = alarm2Invalue;
                $(".open-alarm-layer").addClass("in");
                if(alarm1Invalue == "없음"){
                    $(".open-alarm-layer").html( alarm1Invalue );
                }else{
                    $(".open-alarm-layer").html( alarmResult );
                }
            }
        });
    }, []);

    return(
        <div className="blacklayer-container alarm-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div className="blgrn-box vertical priv">
                    <div className="blgr-title">알림</div>

                    <div>
                        <div className="picker-container w2">
                            <div className="swiper-container pickslide-alarm1">					
                                <div className="swiper-wrapper">
                                    <div className="swiper-slide"><span>없음</span></div>
                                    <div className="swiper-slide"><span>스케줄</span></div>
                                </div>
                            </div>

                            <div className="swiper-container pickslide-alarm2">					
                                <div className="swiper-wrapper">
                                    <div className="swiper-slide"><span>5분 전</span></div>
                                    <div className="swiper-slide"><span>10분 전</span></div>
                                    <div className="swiper-slide"><span>15분 전</span></div>
                                    <div className="swiper-slide"><span>30분 전</span></div>
                                    <div className="swiper-slide"><span>1시간 전</span></div>
                                    <div className="swiper-slide"><span>2시간 전</span></div>
                                    <div className="swiper-slide"><span>1일 전</span></div>
                                    <div className="swiper-slide"><span>2일 전</span></div>
                                    <div className="swiper-slide"><span>1주 전</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="tbns-area">
                        <a className="btn-round gray">취소</a>
                        <a className="btn-round wht">확인</a>
                    </div>

                </div>
            </div>
        </div>
    );
}